import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { ROOT_API } from "../../config/global.config";
import { defaultHeaders } from "../../utils/params";
import { API_TAGS } from "../constants";

export const rootApi = createApi({
  reducerPath: "vms-root-api",
  baseQuery: async (args, api, extraOptions) => {
    const baseQuery = fetchBaseQuery({
      baseUrl: ROOT_API,
      prepareHeaders: async (headers, { getState }) => {
        const token = (getState() as any)?.auth?.access_token;
        return defaultHeaders(headers, token);
      },
    });
    const result = await baseQuery(args, api, extraOptions);
    return result;
  },
  tagTypes: Object.values(API_TAGS),
  keepUnusedDataFor: 2,
  endpoints: () => ({}),
});
